import { useProcessData } from "./ProcessDataContext";
import { ITimePoint } from "./TimePoint";

export default function TimePointBg({ data }: { data: ITimePoint }) {
    const [startTime] = useProcessData(state => state.start);
    const [finishTime] = useProcessData(state => state.finish);

    if (!data.finish)
        return null;

    const duration = finishTime - startTime;

    const left =
        duration > 0
            ? ((data.start - startTime) / duration) * 100
            : 0;

    const width =
        data.finish && duration > 0
            ? ((data.finish - data.start) / duration) * 100
            : undefined;

    return (
        <div
            className='absolute top-0 h-[50px]'
            style={{
                left: `${left}%`,
                width: width ? `${width}%` : undefined,
                backgroundColor: "color-mix(in srgb, var(--border3) 25%, transparent)",
            }}
        />
    );
}